import axios, { awaitWrapper } from "request/axios";

/* 个人中心 */
export const getCompany = () => {
  return awaitWrapper(axios.get("/v1/partner/operation/company"), true);
};

/* 退出 */
export const getLogout = () => {
  return awaitWrapper(axios.get("/v1/partner/operation/user/logout"), true);
};

/* 获取当前合作商的状态 */
export const getStatus = () => {
  return awaitWrapper(axios.get("/v1/partner/operation/user/status"), true);
};

/* 菜单权限 */
export const getMenuPermission = () => {
  return awaitWrapper(
    axios.get(
      `/v1/partner/operation/listableManage/dynamicField?permissionCodes=menu_permission_code`
    ),
    true
  );
};

/* 极验第1步 */
export const getGeetest1 = (mobile: string) => {
  return awaitWrapper(
    axios.get(
      `/v1/partner/operation/user/register/api1?mobile=${mobile}`
    ),
    true
  );
};

/**
 * 发送验证码
 * @param 
 * {
    "api2VO": {
      "challenge": "string",
      "seccode": "string",
      "status": "string",
      "validate": "string"
    },
    "areaCode": "string",
    "flowId": "string",
    "mobile": "string"
  } 
 * @returns 
 */
export const sendSms = (data: any) => {
  return awaitWrapper(
    axios.post(
      `/v1/partner/operation/user/sendSms`,
      data
    ),
    true
  );
};

/** 验证验证码
 * @param 
 * {
 *  phone: "string",
 *  verifyCode: "string",
 * } 
 * @returns 
 * 
 */
export const checkSms = (data: any) => {
  return awaitWrapper(
    axios.post(
      `/v1/partner/operation/user/checkSms`,
      data
    ),
    true
  );
};

/**
 * 校验身份信息
 * @param 
 * {
    "enterInfoIDCard": "",
    "enterInfoName": ""
  }
 * @returns 
 */
export const identificationCheck = (data: any) => {
  return awaitWrapper(
    axios.post(
      `/v1/partner/operation/company/identification-check`,
      data
    ),
    true
  );
};

/**
 * 更新个人信息
 * @param 
 * {
    "enterInfoIDCard": 110101199001011230,
    "enterInfoName": "张三",
    "id": 0,
    "idCardBackUrl": "https://example.com/back.jpg",
    "idCardFrontUrl": "https://example.com/front.jpg",
    "phone": 13800138000,
    "receiveInfoAccountName": "张三",
    "receiveInfobankAddress": "北京市朝阳区",
    "receiveInfobankName": "中国工商银行",
    "receiveInfobankNo": 6222021234567890000,
    "verifyCode": 123456
  }
 * @returns 
 */
export const updateCompany = (data: any) => {
  return awaitWrapper(
    axios.put(
      `/v1/partner/operation/company`,
      data
    ),
    true
  );
};

/**
 * 签约
 * @param id: 合作商id，userInfo中的id
 * @returns 
 */
export const signCompany = (id: number) => {
  return awaitWrapper(
    axios.post(
      `/v1/partner/operation/company/${id}/sign`,
      {},
      { 
        headers: { 
          'Content-Type': 'application/pdf',
        },
        responseType: 'blob'
      }     
    ),
    true
  );
};

/** 获取身份信息 */
export const getCompanyIdentity = () => {
  return awaitWrapper(
    axios.get(
      `/v1/partner/operation/company/identity`
    ),
    true
  );
};

/** 确认主体变更 */
export const contractSubjectConfirm = (id: number, agree: boolean) => {
  return awaitWrapper(
    axios.post(
      `/v1/partner/operation/company/${id}/contract-subject-confirm`,
      { agree }
    ),
    true
  );
};

/** 下载合同PDF */
export const getContractPdf = (id: number) => {
  return awaitWrapper(
    axios.get(
      `/v1/partner/operation/company/${id}/contract-pdf`,
      {
        responseType: 'blob'
      }
    ),
    true
  );
};

/* 上传图片 */
export const uploadImage = (data: any) => {
  return awaitWrapper(
    axios.post(
      `/oss/image/upload/https`,
      data
    ),
    true
  );
};

